import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';

export default (makeCall: MakeCall) => (
  conversationID: number,
  toArchive: boolean,
) =>
  makeCall(
    'PUT',
    `${APIV2_URL}/conversation/${conversationID}/${
      toArchive ? 'archive' : 'unarchive'
    }`,
  );
